import React from 'react'
import {connect} from 'react-redux'
import nesProp from 'nested-property'
import styles from './DSWizardHelper.scss'
import {isDocumentMustBeSigned} from './DSWizardHelper'
import documentStyles from './documents.scss'
import {isSignedTheDocument, shouldToLinkWithContract, shouldToLinkWithClaim, shouldToLinkWithTarification} from './documentsHelpers'
import cs from 'classnames'
import i18n from 'lib/i18n'
import * as c from 'state/constants'

// variables out of module
const _ = i18n('dsdocuments')

/**
 * This module render a button witch can be used to link or upload DSDocument
 */
@connect(
    (state) => {
        return {
            DSDocumentOriginTypes: nesProp.get(state, "app.security.DigitalSignatureHardLists.DSDocumentOriginTypes"),
        }
    }
)
export default class LinkAndUploadButton extends React.Component {
	static propTypes = {
        dsDocument: React.PropTypes.object,
        templates: React.PropTypes.array,
        openLinkAndUploadWizard: React.PropTypes.func,
        key: React.PropTypes.string,
    }

    constructor(props) {
        super(props)
        this.state= {}
    }

    /**
     * This function fired when the module attached
     */
    componentDidMount() {

    }

    /**
     * This function handle the onclick on action button for a DSDocument
     * @param {*} dsDocument
     */
    onDSDocumentActionClick(dsDocument) {
        // no document cancel action
        if (!dsDocument) {
            return false
        }

        let buttonTextForAction = ''

        switch(true) {
            case shouldToLinkWithContract(dsDocument): {
                buttonTextForAction = _("linkContract")
                break
            }
            case shouldToLinkWithClaim(dsDocument): {
                buttonTextForAction = _("linkClaim")
                break
            }
            case shouldToLinkWithTarification(dsDocument): {
                buttonTextForAction = _("linkTarification")
                break
            }
        }

        // open wizard to link and upload document
        return this.openLinkAndUploadWizard(dsDocument)
    }

    /**
     *
     * @param {*} dsDocument
     */
     openLinkAndUploadWizard(dsDocument) {
        this.props.openLinkAndUploadWizard(dsDocument)
    }

    /**
     * This function will return with a translated text for the action button by processing a document record.
     * @param {Object} dsDocument
     * @returns String - the text of the button for action.
     */
    determineActionButtonText (dsDocument) {
        let buttonTextForAction = ''

        switch(true) {
            case shouldToLinkWithContract(dsDocument): {
                buttonTextForAction = _("linkContract")
                break
            }
            case shouldToLinkWithClaim(dsDocument): {
                buttonTextForAction = _("linkClaim")
                break
            }
            case shouldToLinkWithTarification(dsDocument): {
                buttonTextForAction = _("linkTarification")
                break
            }
            default: {
                buttonTextForAction = _("uploadDocument")
            }
        }

        return buttonTextForAction
    }

    /**
     * Main render function
     */
    render() {
        const {dsDocument, templates, key, DSDocumentOriginTypes} = this.props

        // avoid total fall in fail
        if (!dsDocument) {
            return (<div>...</div>)
        }

        let documentTemplateId = nesProp.get(dsDocument, "documentTemplateId")
        let docTemplateArray = templates && templates.filter(
                (oneTemplate) => (String(oneTemplate._id) === String(documentTemplateId))
            ) || false

        let documentTemplate = docTemplateArray && docTemplateArray[0] || false
        let mustBeSigned = isDocumentMustBeSigned(DSDocumentOriginTypes, dsDocument.origin, documentTemplate)
        let isSigned = isSignedTheDocument(dsDocument)
        // only in case when the value is FALSE should be uneditable, else the package is an older version instance or editable else not editable so false.
        // so FALSE mean false only, rest of the values means editable or old version of package where this value is not set, that means must checked other conditions
        let packageIsEditable = (dsDocument && dsDocument.package && (dsDocument.package.isEditable === false)) ? false : true

        return (
            <div key={key}>
                {(!dsDocument.uploadedToOracle && (!mustBeSigned || (mustBeSigned && isSigned) || shouldToLinkWithContract(dsDocument)) &&
                !packageIsEditable) ?
                <button className={cs(documentStyles.greenButton, "enabled")}
                    onClick={(ev) => {
                        ev.stopPropagation()
                        return this.onDSDocumentActionClick(dsDocument)
                    }
                }>
                    {this.determineActionButtonText(dsDocument)}
                </button>
                : ""}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/linkAndUploadButton.jsx